import { IUserMilestone } from "@faire/web-api--source/indigofair/data/IUserMilestone";
import { useEffect, useState, useCallback } from "react";

import {
  useMilestone,
  useRecordMilestoneByDay,
} from "@faire/retailer-visitor-shared/stores/domain/useMilestone";

export const useSilenceWithMilestone = (
  milestone: IUserMilestone.RetailerMilestone,
  maxViewCount: number,
  delayMilestoneIncrement?: boolean
) => {
  const [isSilenced, setIsSilenced] = useState(true);
  const { count } = useMilestone(milestone);
  const recordMilestoneByDay = useRecordMilestoneByDay();

  useEffect(() => {
    if (count <= maxViewCount) {
      setIsSilenced(false);

      if (!delayMilestoneIncrement) {
        recordMilestoneByDay(milestone);
      }
    }
  }, [
    count,
    delayMilestoneIncrement,
    maxViewCount,
    milestone,
    recordMilestoneByDay,
  ]);

  const updateMilestoneOnView = useCallback(() => {
    if (count <= maxViewCount) {
      recordMilestoneByDay(milestone);
    }
  }, [count, maxViewCount, milestone, recordMilestoneByDay]);

  return {
    isSilenced,
    updateMilestoneOnView,
  };
};
